const ensureArray = maybeArray =>
  Array.isArray(maybeArray) ? maybeArray : []

export default ensureArray
